import styled from "@emotion/styled";
const MessageActions = {
    Wrapper: styled.div `
    position: absolute;
    top: -0.8em;
    right: 1em;
    z-index: 1;
    display: none;
    padding: 0.3em 0.5em;
    background: ${({ theme }) => theme.color.background};
    border: solid 0.1em ${({ theme }) => theme.color.backgroundAccent};
    border-radius: 0.2em;
  `,
    ActionButton: styled.button `
    height: 1em;
    width: 1em;
    border: none;
    background: none;
    cursor: pointer;
    padding: 0;
    margin-right: 0.5em;
    fill: ${({ theme }) => theme.color.text};
    color: ${({ theme }) => theme.color.text};
    :hover {
      fill: ${({ theme }) => theme.color.backgroundBrand};
      color: ${({ theme }) => theme.color.backgroundBrand};
    }
  `,
};
export default MessageActions;
//# sourceMappingURL=MessageActions.styled.js.map